import React, { useState } from 'react';
import clsx from 'clsx';
import './card-image.scss';
import { Icon } from '@ampol/design-system';

/**
 * Display Card Image Component
 * @param isLarge Flag to determine whether card image should be displayed as the large or small variant
 * @param isDigital If true then show E icon in top right corner
 * @param imageSource Image source for card image
 * @param useCacheImage If true, use already downloaded cached image.  default false: always download the latest image
 * @returns JSX Element
 */

const CardImage = ({ isLarge, isDigital, imageSource, useCacheImage = false }) => {
  const [isLoaded, setIsLoaded] = useState(!!imageSource);
  const imgSrc = imageSource ? `${imageSource}${useCacheImage ? '' : `?${new Date().getTime()}`}` : null;

  return (
    <div className={clsx('card-image', { 'card-image--large': isLarge, 'card-image--loading': !isLoaded })}>
      {imgSrc && <img src={imgSrc} alt="card-image" className="card-image__img" width="100%" height="auto" onLoad={() => setIsLoaded(true)} />}
      {isDigital && <Icon url="/icons/e-digital.svg" size={23} className="card-image__icon" />}
    </div>
  );
};

export default CardImage;
